import { render, staticRenderFns } from "./ModalAccountModeration.vue?vue&type=template&id=156761aa&"
import script from "./ModalAccountModeration.vue?vue&type=script&lang=js&"
export * from "./ModalAccountModeration.vue?vue&type=script&lang=js&"
import style0 from "./ModalAccountModeration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports